export default "__VITE_ASSET__NBwTZoUK__"